
import { AutoComplete, AutoCompleteProps } from 'antd';
import cs from "classnames";
import Styles from "./Styles.module.scss";


export default function MPAutoComplete({ className, ...props }: AutoCompleteProps) {
    return (
        <>
            <AutoComplete
                className={cs(Styles?.MPAutoComplete, className)}
                {...props}
            />
        </>
    );
}
